<template>
    <div id='weight'>
        <div class="h">寄 <span class="num">{{this.$store.getters.totalParts}}</span> 件</div>
        <div class="b">
            <div class="pubw">
                <div class="top">
                    <div class="totalWeight">
                        <div class="h">總體積重量約</div>
                        <div class="totalnum">
                            {{this.$store.getters.totalVolume}}KG
                        </div>
                        <div class="tips" v-show="this.$store.getters.totalVolume>= weight">
                            <span>以此重量收費</span>
                        </div>
                    </div>
                    <div class="border"></div>
                    <div class="actualWeight">
                        <div class="h">實際總重量</div>
                            <el-input onkeyup="value=value.replace(/[^\d]/g,'')" v-model.number="weight"></el-input>
                        <div class="tips" v-show="weight > this.$store.getters.totalVolume">
                            <span>以此重量收費</span>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div class="top">
                        <span>運費以體積重或實際重量來計算，價高者為準。</span>
                        <span class="heloIcon" @click="Alert">
                            <span class="el-icon-question"></span>
                        </span>
                    </div>
                    <div class="bottom">
                        <optionsButton class="nextButton" :title="'以' + maxWeight + 'KG預算運費'" :callback="next" icon="el-icon-right"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- 预算物品重量提示框 -->

        <FreightAlert :alertShow="showAlert" :callback="Alert"/>
    </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
import optionsButton from '@/components/optionButton'
import FreightAlert from "@/components/FreightAlert/FreightAlert.vue"
export default {
    props:["num","callback","getMaxWeight"],
    name:'Weight',
    components:{
        optionsButton,
        FreightAlert
    },
    data(){
        return {
            // 重量
            weight:this.$store.state.weight,
            // 控制物品提示是否展示
            showAlert:false
        }
    },
    methods: {
        ...mapMutations(['UPDATEWEIGHT',"SETPRICE","INITBUDGET"]),

        // 监听用户点击获取预算
        async next(){

            let budgetForm  = this.$store.state.budgetForm
            let volume = this.$store.getters.totalVolume
            let maxWeight = volume >= this.weight? volume : this.weight
            

            // 判断用户是否填写了寄件地/收件地/選擇寄件/總重量
            if(!budgetForm.endId || !budgetForm.startId)return this.$message.error("請選擇發貨地和收貨地")

            if(volume<=0)return this.$message.error("請選擇物品重量或者新增物品數量")

            if(this.weight <= 0)return this.$message.error("請輸入物品實際總總量")

            // 发送获取预算请求
            let res = await this.$http.get(`app/data/getPrice?weight=${maxWeight}&startId=${budgetForm.startId}&endId=${budgetForm.endId}`)
            console.log(res,"预算结果")
            if(!res.data.success) return this.$message.error("獲取預算失敗")

            if(res.data.data.length===0) return this.$message.error("當前起始點沒有路線資訊")

            this.$message.success("獲取預算成功")
            this.$bus.$emit("getRouteList",res.data.data)
        },
        // 关闭或开启物品提示框
        Alert(){
            this.showAlert = !this.showAlert
        },
    },
    computed:{
        maxWeight(){
            let maxWeight = this.$store.getters.totalVolume >= this.weight ? this.$store.getters.totalVolume : this.weight
            this.getMaxWeight(maxWeight)
            return  maxWeight
        }
    },
    watch:{
        weight(value,v){
            this.UPDATEWEIGHT(value)
        }
    },
    mounted() {
        this.weight = this.$store.state.weight
    },
}
</script>

<style lang="less">
    #weight{
        padding-top: 30px;
        .h{
            text-align: center;
            font-size:17px;
            .num{
                color:@colorMain ;
                font-size: 18px;
                font-weight: 550;
            }
        }
        .b{
            background-color: #fff;
            margin-top: 30px;
            padding-bottom: 50px;
            .pubw>.top{
                display: flex;
                justify-content: space-around;
                padding-top:20px;
                height: 170px;
                .border{
                    height: 80%;
                    width: 3px;
                    background-color: #e8e8e8;
                }
                .totalWeight,
                .actualWeight{
                    width: 30%;
                    text-align: center;
                    .h{
                        font-size: 17px;
                        font-family:PingFang HK;
                        font-weight:550;
                    }
                    .el-input{
                        display: flex;
                        justify-content: center;
                        margin: 10px 0;
                    }
                    .el-input__inner{
                        height: 60px;
                        border-radius: 10px;
                        text-align: center;
                        width: 175px;
                        margin: 0 auto;
                        border: 2px solid #DCDFE6;
                        font-size: 17px;
                        color: @colorMain ;
                        font-weight:550;
                    }
                    .tips{
                        width: 110px;
                        margin: 0 auto;
                        border-radius: 10px;
                        color: #fff ;
                        background: @colorMain ;
                        font-size:13px;
                        height: 25px;
                        line-height: 25px;
                    }
                }
                .totalWeight{
                    line-height: 50px;
                    .totalnum{
                        font-size: 30px;
                    }
                }
                .actualWeight{
                    text-align: center;
                    line-height: 35px;
                }
                
            }
            .bottom{
                .top{
                    display: flex;
                    justify-content: center;
                    margin:20px 0;
                }
                .nextButton{
                    width: 100%;
                }
                .heloIcon{
                    color: @colorMain ;
                    &:hover{
                        cursor: pointer;
                        opacity: .8;
                    }
                }
            }
        }
    }
</style>